import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import DataTable from '../../../components/DataTable/DataTable';
import FieldSetNewAssessmentTabular
    from '../../../components/FieldSetNewAssessmentTabular/FieldSetNewAssessmentTabular';

class QuestionnaireFormTabularTrueFalse extends React.Component {
    componentDidMount() {
    }

    render() {
        const { questions } = this.props;
        const data = questions.map(question => ({
            question: question.text,
            question_id: question.id,
            true_id: question.options.find(option => option.text === 'True').id,
            false_id: question.options.find(option => option.text === 'False').id,
            options: question.options,
        }));
        const columns = [
            {
                accessor: 'question',
                Cell: props => props.data.question,
                sortable: false,
                title: '',
            },
            {
                accessor: 'true',
                Cell: props => (
                    <Field
                        name={`${props.data.question_id}`}
                        render={fieldProps => (
                            <FieldSetNewAssessmentTabular
                                data={props.data}
                                optionId={props.data.true_id}
                                options={props.data.options}
                                booleanField
                                {...fieldProps}
                            />
                        )}
                    />
                ),
                sortable: false,
                title: 'True',
            },
            {
                accessor: 'false',
                Cell: props => (
                    <Field
                        name={`${props.data.question_id}`}
                        render={fieldProps => (
                            <FieldSetNewAssessmentTabular
                                data={props.data}
                                optionId={props.data.false_id}
                                options={props.data.options}
                                booleanField
                                {...fieldProps}
                            />
                        )}
                    />
                ),
                sortable: false,
                title: 'False',
            },
        ];
        const sortable = false;
        const pageable = false;

        return (
            <React.Fragment>
                <DataTable
                    className="data-table"
                    columns={columns}
                    data={data}
                    sortable={sortable}
                    pageable={pageable}
                />
            </React.Fragment>
        );
    }
}
QuestionnaireFormTabularTrueFalse.propTypes = {
    questions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({})),
};
QuestionnaireFormTabularTrueFalse.defaultProps = {
    options: [],
};

export default QuestionnaireFormTabularTrueFalse;
